export default "__VITE_ASSET__Cfnp6kXR__"